import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { CategoriasInformePlanTrabajoDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class CategoriasInformePlanTrabajoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCategoriasInformePlanTrabajoActivosService(): Observable<BodyListResponse<CategoriasInformePlanTrabajoDTO>> {
    return this.http.get<BodyListResponse<CategoriasInformePlanTrabajoDTO>>(API_URL + '/api/v1/categoriasInformePlanTrabajo');
  }

  getCategoriasInformePlanTrabajoService(): Observable<BodyListResponse<CategoriasInformePlanTrabajoDTO>> {
    return this.http.get<BodyListResponse<CategoriasInformePlanTrabajoDTO>>(API_URL + '/api/v1/categoriasInformePlanTrabajo/todos');
  }

  guardarCategoriasInformePlanTrabajoService(categoriasInformePlanTrabajoDTO: CategoriasInformePlanTrabajoDTO): Observable<BodyResponse<CategoriasInformePlanTrabajoDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/categoriasInformePlanTrabajo', categoriasInformePlanTrabajoDTO);
  }

  getCategoriasInformePlanTrabajoPorCodigoService(codigo: string): Observable<BodyResponse<CategoriasInformePlanTrabajoDTO>> {
    return this.http.get<BodyResponse<CategoriasInformePlanTrabajoDTO>>(API_URL + '/api/v1/categoriasInformePlanTrabajo/' + codigo);
  }

  getCategoriasPlanTrabajo(codigo: string): Observable<BodyListResponse<CategoriasInformePlanTrabajoDTO>> {
    return this.http.get<BodyListResponse<CategoriasInformePlanTrabajoDTO>>(API_URL + '/api/v1/categoriasInformePlanTrabajo/plan/' + codigo);
  }
}
